var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-main"},[_c('keep-alive',{attrs:{"max":"1"}},[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"router-container"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"router-container"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }